import React, { useState, useEffect } from "react";
import highcharts3d from "highcharts/highcharts-3d.src";
import { useScreenSize } from "../../../components";

const PieChart = ({ HighchartsReact, Highcharts, title, data, colors }) => {
  highcharts3d(Highcharts);
  const dimensions = useScreenSize();
  const [direction, setDirection] = useState("horizontal");
  const [vAlign, setVAlign] = useState("middle");
  const [lAlign, setLAlign] = useState("right");
  const [chartWidth, setChartWidth] = useState(400);

  useEffect(() => {
    if (dimensions.width < 768) {
      setDirection("horizontal");
      setVAlign("top");
      setLAlign("left");
      setChartWidth(300);
    } else {
      setDirection("vertical");
      setVAlign("middle");
      setLAlign("right");
      setChartWidth(400);
    }

    // console.log(dimensions.width);
  }, [dimensions]);

  useEffect(() => {}, []);

  const options = {
    colors: colors
      ? colors
      : [
          "#6735A8",
          "#72ADFF",
          "#00C74C",
          "#FF6A3A",
          "#FFB53A",
          "#1e6c70",
          "#b01098",
          "#b0105d",
          "#edce05",
        ],
    chart: {
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
      width: chartWidth,
      height: 350,
    },
    title: {
      text: "",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },

    legend: {
      enabled: true,
      layout: direction,
      verticalAlign: vAlign, //middle
      align: lAlign,
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginTop: 10,
    },
    tooltip: {
      pointFormat:
        "Percentage: <b>{point.percentage:.1f}%</b> <br /> Total: <b>{point.y}</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        depth: 35,
        dataLabels: {
          enabled: false,
          format: "{pointer.name}",
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "pie",
        name: title,
        data,
      },
    ],
  };

  // console.log(data);

  return (
    <div className=" md:px-7 py-5 px-5  w-full">
      <h4 className="">{title}</h4>

      {data && data.length < 1 ? (
        <>
          <div className="w-full flex justify-center my-[7.7rem] ">
            <img src={require("../../../../assets/images/noData.svg")} alt="" />
          </div>
        </>
      ) : (
        <div className="  w-full flex items-center justify-center ">
          <HighchartsReact
            // containerProps={{ style: { height: "100%" } }}
            highcharts={Highcharts}
            // options={formatChartData(chartData.total, "Total")}
            options={options}
            // constructorType={"stockChart"}
            updateArgs={[true, true, true]}
          />
        </div>
      )}
    </div>
  );
};

export default PieChart;
